// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_UpdateConfigResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for PUT /payments/anticipations/update_config/{subaccount_id}
 *
 * Returns the merged-and-persisted local config (`local_config`) plus the
 * upstream provider's anticipation-config result (`provider_result`). The
 * provider call only runs when `auto_credit_card` is supplied, so
 * `provider_result` is nullable (and is null on the no-toggle / provider-error
 * paths). Both fields point at sibling Row classes so the Spatie TS pipeline
 * projects a typed interface for each, and FF_STRICT_ROW_CONTRACTS=1 catches
 * drift if either source shape gains a key not declared on its Row.
 *
 * @see anticipations.php::update_config()
 */
import type { SubaccountsAnticipations_UpdateConfigLocalConfigRow } from './SubaccountsAnticipations_UpdateConfigLocalConfigRow'
import type { SubaccountsAnticipations_UpdateConfigProviderResultRow } from './SubaccountsAnticipations_UpdateConfigProviderResultRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsAnticipations_UpdateConfigResponseDados {
local_config: SubaccountsAnticipations_UpdateConfigLocalConfigRow
provider_result?: SubaccountsAnticipations_UpdateConfigProviderResultRow
}

export type SubaccountsAnticipations_UpdateConfigResponse = ApiResponse<SubaccountsAnticipations_UpdateConfigResponseDados>;

registerResponseContract('SubaccountsAnticipations_UpdateConfigResponse', {
  local_config: {
    type: 'object',
    required: true,
    fields: {
      enabled:          { type: 'boolean', required: false },
      auto_credit_card: { type: 'boolean', required: false },
      min_amount:       { type: 'number',  required: false },
      updated_at:       { type: 'string',  required: false },
      updated_by:       { type: 'string',  required: false },
    },
  },
  provider_result: {
    type: 'object',
    required: false,
    fields: {
      creditCardAutomaticEnabled: { type: 'boolean', required: false },
    },
  },
})
